// Internal Config
// Client Config when Remote Config is disabled
export function adaptHeartbeatClientConfig(config) {
    return config;
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptHeartbeatRemoteConfigSplit(config) {
    var _config_remoteConfig;
    return {
        enabled: Boolean((_config_remoteConfig = config.remoteConfig) === null || _config_remoteConfig === void 0 ? void 0 : _config_remoteConfig.enabled),
        config: {}
    };
}

//# sourceMappingURL=heartbeat-config-adapter.js.map